import AppBarOnlyTemplate from './AppBarOnlyTemplate'

export default AppBarOnlyTemplate
